import { SummaryActions, SummaryActionTypes } from '../actions/summary.actions';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { SummaryConfig } from '../models/summary-element-config';
import { ReviewActionTypes, ReviewActions } from '../../review/actions/review.actions';

export interface SummaryBaseState {
  termsApproved: boolean;
  orderDraft: Order | null;
  config: SummaryConfig;
  specialInvoice?: boolean;
}

export const initialDraftState: SummaryBaseState = {
  termsApproved: false,
  orderDraft: null,
  config: null,
  specialInvoice: false,
};

export function summaryStateReducer(
  state = initialDraftState,
  action: SummaryActions | ReviewActions,
): SummaryBaseState {
  switch (action.type) {
    case SummaryActionTypes.SET_TERMS: {
      return {
        ...state,
        termsApproved: action.payload,
      };
    }
    case SummaryActionTypes.SET_SPECIAL_INVOICE: {
      return {
        ...state,
        specialInvoice: action.payload,
      };
    }
    case SummaryActionTypes.LOAD_CONFIG_COMPLETE: {
      return {
        ...state,
        config: action.payload,
      };
    }
    case SummaryActionTypes.RESET_SUMMARY: {
      return {
        ...state,
        specialInvoice: null,
        termsApproved: null,
      };
    }
    // Listen to draft actions
    case ReviewActionTypes.LOAD_DRAFT_COMPLETE: {
      return {
        ...state,
        orderDraft: action.payload.orderDraft,
      };
    }
    case ReviewActionTypes.RESET_DRAFT: {
      return {
        ...state,
        orderDraft: null,
      };
    }
    default: {
      return state;
    }
  }
}
